import { useQuery } from '@tanstack/react-query';
import cartItemAPI from 'src/api/cartItem';

import { useAppData } from '@helpers/use';

export const cartItemCountKey = () => ['cart', 'item', 'count'];

export const useCartItemCount = () => {
  const { appData } = useAppData();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: cartItemCountKey(),
    queryFn: async () => {
      const response = await cartItemAPI.getCartItemCount();
      return response.data;
    },
    enabled: !!appData?.isCartEnabled,
  });

  const handleFetchCartItemCount = () => {
    if (appData?.isCartEnabled) refetch();
  };

  let itemCount = 0;
  if (data && !isLoading && !isError) {
    itemCount = data.count;
  }

  return {
    itemCount,
    isLoading,
    isError,
    handleFetchCartItemCount,
  };
};
